import { useContext, useState, useEffect } from "react";
import {
  StyleSheet,
  View,
  Text,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import SafeAreaView from "../components/SafeAreaView";
import SensorBranchItem from "../components/SensorBranchItem";

import { AuthContext } from "../context/AuthContext";
import * as Config from "../config";
import axios from "axios";
import qs from "qs";
import PageHeader from "../components/PageHeader";
import { EventRegister } from "react-native-event-listeners";
import { getSchemeStyle } from "../context/helper";
import ActivityScreen from "./activityscreen";

const BranchScreen = ({ route, navigation }) => {
  const schemeStyles = getSchemeStyle();

  const { userToken, useFirm } = useContext(AuthContext);
  const { branchid } = route.params;

  const [dataLoaded, setDataLoaded] = useState(false);
  const [sensorData, setSensorData] = useState([]);
  const [branchName, setBranchName] = useState("");

  const loadData = async () => {
    setDataLoaded(false);

    const url = `${Config.BASE_URL}/getdata`;
    let data = {
      action: "branchview",
      firmid: useFirm.current,
      branchid: branchid,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        let _sensordata = res.data;
        //console.log(_sensordata);
        if (_sensordata && _sensordata.result == "OK") {
          setBranchName(_sensordata.branchName);
          setSensorData(_sensordata.data);
        }
      })
      .catch((e) => {
        console.log(`BranchView error ${e}`);
      });
    setDataLoaded(true);
  };

  useEffect(() => {
    loadData();
  }, []);
  useEffect(() => {
    const emitSubscribe = EventRegister.addEventListener(
      Config.Events.BRANCH_CHANGE,
      (msg) => {
        if (branchid===msg.branchid)
          setBranchName(msg.branchname);
      }
    );
    return () => {
      EventRegister.removeEventListener(emitSubscribe);
    };
  }, [branchid]);

  if (!dataLoaded) {
    return (
      <ActivityScreen />
    );
  }

  return (
    <SafeAreaView style={[styles.mainContainer,schemeStyles.Background]}>
      <PageHeader navigation={navigation} showBack={true} />
      <View style={styles.branchHeaderContainer}>
        <Text style={[styles.branchHeaderText,schemeStyles.defaultText]}>Messdaten {branchName}</Text>
      </View>
      {sensorData.length > 0 ? (
        <ScrollView style={styles.scrollContainer}>
          {sensorData.map((item) => (
            <SensorBranchItem
              key={item.id}
              item={item}
              onPress={() => {
                navigation.navigate("Sensor", {
                  branchid: branchid,
                  sensorid: item.id,
                });
              }}
            />
          ))}
        </ScrollView>
      ) : (
        <Text></Text>
      )}
    </SafeAreaView>
  );
};

export default BranchScreen;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingVertical: 20,
  },
  scrollContainer: {
    paddingHorizontal: 10,
  },
  branchHeaderContainer: {
    marginHorizontal: 20,
    marginBottom: 20,
  },
  branchHeaderText: {
    fontSize: 18,
    fontFamily: "Roboto-Medium",
  },
});
